import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { toast, ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { Button, Form } from 'react-bootstrap'
import '../../../assets/css/bootstrap-reset.sass'
import '../../../assets/css/shoob-reset.sass'
import styles from './AddYearbookSaleButton.module.sass'
import Modal from '../../common/Modal'
import Select from 'react-select'
import {
  Package,
  Price,
  Student,
  User,
} from '../../../models/_models'
import createOrder from './CreateOrder'
import Divider from '../../Divider'

const findPrice = (yearbookPackage) => {
  const { options } = yearbookPackage

  const prices = options.map((option) => option.prices).flat()

  if (prices.length > 0) return prices[0].price

  return null
}

const AddYearbookSaleButton = ({ userId, schoolId }) => {
  const [open, setOpen] = useState(false)
  const [formData, setFormData] = useState({})
  const [user, setUser] = useState()
  const [yearbookPackage, setYearbookPackage] = useState()
  const [yearbookPackages, setYearbookPackages] = useState([])
  const [currentYearbookPackage, setCurrentYearbookPackage] = useState({})

  useEffect(() => {
    if (yearbookPackages.length === 0) return

    setCurrentYearbookPackage(yearbookPackages[0])
  }, [yearbookPackages.length])

  useEffect(() => {
    if (!currentYearbookPackage.id) return

    const suggestedPrice = findPrice(currentYearbookPackage)

    setFormData({ ...formData, price: suggestedPrice })
  }, [currentYearbookPackage.id])

  useEffect(() => User.find(userId).then((res) => setUser(res.data)), [])

  useEffect(() => {
    if (!user) return

    const priceScope = Price.where({ forSchoolAnytime: schoolId })

    Package
      .includes({ options: 'prices' })
      .merge({ prices: priceScope })
      .where({ schoolId })
      .where({ name: { match: 'yearbook' } })
      .all()
      .then((res) => {
        if (res.data.length < 1) return

        setYearbookPackage(res.data[0])
        setYearbookPackages(res.data)
        setFormData({ ...formData, price: findPrice(res.data[0]) })
      })
  }, [user])

  const show = () => setOpen(true)
  const hide = () => setOpen(false)

  const handleSubmit = (evt) => {
    evt.preventDefault()

    createOrder(currentYearbookPackage, schoolId, { ...formData })
      .then((res) => {
        if (!res) {
          const content = []
          if (formData.quantity === '0') {
            content.push('You must specificy the number of yearbooks to order.')
          }
          if (formData.price === '0') {
            content.push('You must specify a price greater than $0.')
          }
          if (content.length === 0) {
            content.push('There was a problem saving your order.')
          }

          toast(content.join(' '), { type: 'error' })
          return
        }

        toast('Successfully saved.', { type: 'success' })
        hide()
        setTimeout(() => window.location.reload(), 500)
      })
      .catch(() => {
        const content = []
        if (formData.quantity === '0') {
          content.push('You must specificy the number of yearbooks to order.')
        }
        if (formData.price === '0') {
          content.push('You must specify a price greater than $0.')
        }
        if (content.length === 0) {
          content.push('There was a problem saving your order.')
        }
        toast(content.join(' '), { type: 'error' })
      })
  }

  const handleChange = (evt) => {
    setFormData({ ...formData, [evt.target.name]: evt.target.value })
  }

  const handleStudentId = async () => {
    if (!formData.studentId) return

    const studentById = await Student.where({ studentId: formData.studentId, schoolId }).first()

    if (studentById && studentById.data) {
      const { firstName, lastName, grade } = studentById.data
      const newFormData = { firstName, lastName, grade }
      setFormData({ ...formData, ...newFormData })
    }
  }

  return (
    <>
      <ToastContainer />
      <Button onClick={show}>
        Add Yearbook Sale
      </Button>
      <Modal modalBodyProps={{ className: styles.modalBody }} closeModal={hide} headerText="Add Sale" modalIsOpen={open}>
        <Form onSubmit={handleSubmit}>
          <Form.Group>
            <Form.Label>Student ID <span style={{ color: 'red' }}>*</span></Form.Label>
            <Form.Control value={formData.studentId || ''} name="studentId" onChange={handleChange} onBlur={handleStudentId} />
          </Form.Group>
          <div style={{ margin: '12px 0', fontSize: '16px' }}>
            <Divider>Or enter student information</Divider>
          </div>
          <Form.Group>
            <Form.Label>Student First Name <span style={{ color: 'red' }}>*</span></Form.Label>
            <Form.Control value={formData.firstName || ''} name="firstName" onChange={handleChange} />
          </Form.Group>
          <Form.Group>
            <Form.Label>Student Last Name <span style={{ color: 'red' }}>*</span></Form.Label>
            <Form.Control value={formData.lastName || ''} name="lastName" onChange={handleChange} />
          </Form.Group>
          <Form.Group>
            <Form.Label>Grade <span style={{ color: 'red' }}>*</span></Form.Label>
            <Form.Control value={formData.grade || ''} name="grade" onChange={handleChange} />
          </Form.Group>
          <div style={{ margin: '12px 0', fontSize: '16px' }}>
            <Divider>Yearbook information</Divider>
          </div>
          <Form.Group>
            <Form.Label>Package <span style={{ color: 'red' }}>*</span></Form.Label>
            <Select
              value={{ label: currentYearbookPackage.name, value: currentYearbookPackage.id }}
              options={yearbookPackages.map((yp) => ({ label: yp.name, value: yp.id }))}
              onChange={(opt) => setCurrentYearbookPackage(yearbookPackages.find((yp) => yp.id === opt.value))}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>Quantity <span style={{ color: 'red' }}>*</span></Form.Label>
            <Form.Control type="number" value={formData.quantity || ''} name="quantity" onChange={handleChange} />
          </Form.Group>
          <Form.Group>
            <Form.Label>Price per Yearbook <span style={{ color: 'red' }}>*</span></Form.Label>
            <Form.Control type="number" value={formData.price !== undefined ? formData.price : ''} name="price" onChange={handleChange} />
          </Form.Group>
          <Form.Group>
            <Form.Label>Notes</Form.Label>
            <Form.Control as="textarea" rows={3} value={formData.notes || ''} name="notes" onChange={handleChange} />
          </Form.Group>
          <div className={styles.formFooter}>
            <Button variant="danger" type="button" onClick={hide}>
              Cancel
            </Button>
            <Button variant="primary" type="submit">
              Place Order
            </Button>
          </div>
        </Form>
      </Modal>
    </>
  )
}

AddYearbookSaleButton.propTypes = {
  userId: PropTypes.number.isRequired,
}

export default AddYearbookSaleButton
